import React from 'react';
import { StatusStep } from './StatusStep';
import { ApiReportStep } from '@/api/types/models.types';
import { APP_COLORS } from '@/config/colors';

export interface OrderTimelineProps {
  steps: ApiReportStep[];
  currentStep: number;
}

export const OrderTimeline: React.FC<OrderTimelineProps> = ({
  steps,
  currentStep,
}) => {
  return (
    <div
      className="flex w-full flex-col items-start gap-[10px] border py-[68px]"
      style={{
        borderColor: APP_COLORS.gray[200],
        backgroundColor: APP_COLORS.primary[200],
      }}
    >
      <div className="container flex flex-col items-start justify-between gap-[22px] md:flex-row">
        {steps.map((step, index) => {
          const isActive = step.order <= currentStep;
          const progress =
            step.order < currentStep
              ? 100
              : step.order === currentStep
                ? 50
                : 0;

          return (
            <StatusStep
              key={step.id}
              step={step}
              isActive={isActive}
              isLast={index === steps.length - 1}
              progress={progress}
              currentStep={currentStep}
            />
          );
        })}
      </div>
    </div>
  );
};
